<div class="clearfix">
  <div class="col-12 md:col-12"><h3>{{'Mg_Deleg' | translate}}</h3></div>
  <div class="col-12 md:col-12">
    <p-tabView
      [controlClose]="true"
      (onChange)="handleChange($event)"
      (onClose)="closeTab($event)"
      [activeIndex]="index"
      >
      <p-tabPanel [header]="'List' | translate" [selected]="0 == index" [headerStyle]="{ 'font-weight': 'bold' }">
        <div class="table-tools">
          <button
            (click)="add($event)"
            class="p-button p-component p-button-text-only btn-square"
            >
            {{'Add_Delegate' | translate}}
          </button>
        </div>
        <br class="col-12 md:col-12" />
        <p-table
          #dt
          [selectionMode]="'single'"
          [columns]="listColumns"
          [value]="results"
          [rows]="100"
          [paginator]="true"
          responsiveLayout="stack"
          [breakpoint]="'960px'"
          (onRowSelect)="showDetails($event)"
          (onFilter)="setFilteredList($event)"
          [sortField]="'name'"
          >
          <ng-template pTemplate="caption">
            <span class="header-grid-wrapper">
              <span class="align-right">{{'Tot' | translate}} {{ results.length }} {{'Delegate_4' | translate}}</span>
            </span>
          </ng-template>
          <ng-template let-columns pTemplate="header">
            <tr>
              <th class="width-col-9 align">
                {{ columns[0].header }}
                <p-dropdown
                  [options]="activList"
                  [style]="{ width: '100%' }"
                  (onChange)="dt.filter($event.value, columns[0].field, 'equals')"
                ></p-dropdown>
              </th>
              <th class="width-col-10 align">
                {{ columns[1].header }}
                <p-dropdown
                  [options]="stateList"
                  [style]="{ width: '100%' }"
                  (onChange)="dt.filter($event.value, columns[1].field, 'equals')"
                ></p-dropdown>
              </th>
              <th [pSortableColumn]="columns[2].field" class="width-auto">
                <p-sortIcon [field]="columns[2].field"></p-sortIcon>{{ columns[2].header }}
                <input
                  (click)="$event.stopPropagation()"
                  pInputText
                  type="text"
                  (input)="dt.filter($event.target.value, columns[2].field, 'contains')"
                  style="color: darkgrey"
                  />
                </th>
                <th [pSortableColumn]="columns[3].field" class="width-col-13">
                  <p-sortIcon [field]="columns[3].field"></p-sortIcon>{{ columns[3].header }}
                  <input
                    (click)="$event.stopPropagation()"
                    pInputText
                    type="text"
                    (input)="dt.filter($event.target.value, columns[3].field, 'contains')"
                    style="color: darkgrey"
                    />
                  </th>
                  <th [pSortableColumn]="columns[4].field" class="width-col-13">
                    <p-sortIcon [field]="columns[4].field"></p-sortIcon>{{ columns[4].header }}
                    <input
                      (click)="$event.stopPropagation()"
                      pInputText
                      type="text"
                      (input)="dt.filter($event.target.value, columns[2].field, 'contains')"
                      style="color: darkgrey"
                      />
                    </th>
                    <th [pSortableColumn]="columns[5].field" class="width-auto">
                      <p-sortIcon [field]="columns[5].field"></p-sortIcon>{{ columns[5].header }}
                      <input
                        (click)="$event.stopPropagation()"
                        pInputText
                        type="text"
                        (input)="dt.filter($event.target.value, columns[5].field, 'contains')"
                        style="color: darkgrey"
                        />
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template let-rowData let-columns="columns" pTemplate="body">
                    <tr [pSelectableRow]="rowData">
                      <td>
                        <div class="align">
                          @if (rowData[columns[0].field]  === 'true') {
                            <i class="pi pi-check md-18" style="color: green"></i>
                          }
                        </div>
                      </td>
                      <td>
                        <div class="align">
                          <span>
                            @if (rowData[columns[1].field]  === true) {
                              <i class="pi pi-clock md-18" style="color: green"></i>
                            }
                            @if (rowData[columns[1].field]  === false) {
                              <i class="pi pi-clock md-18" style="color: darkgrey"></i>
                            }
                          </span>
                        </div>
                      </td>
                      <td class="width-auto">
                        {{ rowData[columns[2].field] }}
                      </td>
                      <td class="width-col-13">
                        {{ rowData[columns[3].field] | datelength | datecompat | date: 'dd/MM/yyyy' }}
                      </td>
                      <td class="width-col-13">
                        {{ rowData[columns[4].field] | datelength | datecompat | date: 'dd/MM/yyyy' }}
                      </td>
                      <td class="width-auto">
                        {{ rowData[columns[5].field] }}
                      </td>
                    </tr>
                  </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">{{'Empty' | translate}}</td>
            </tr>
          </ng-template>
                </p-table>
              </p-tabPanel>
              @for (item of itemsSelected; track item; let i = $index) {
                <p-tabPanel
                  header="{{ item._label }}"
                  [selected]="i == index - 1"
                  [closable]="true"
                  >
                  @if (item.id === -1) {
                    <app-add-delegate
                      [fromUser]="fromUser"
                      [toUser]="toUser"
                      (onCancel)="cancelAdd($event)"
                      (onValidate)="addTab($event)"
                      >
                    </app-add-delegate>
                  }
                  @if (item.id !== -1) {
                    <app-edit-delegate
                      [item]="item"
                      [delegate]="delegate"
                      [fromUser]="fromUser"
                      [toUser]="toUser"
                      (onCancel)="closeTab($event)"
                      (onValidate)="validateTab($event)"
                      >
                    </app-edit-delegate>
                  }
                </p-tabPanel>
              }
            </p-tabView>
          </div>
        </div>

